import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidatePasswordComponent } from './validate-password.component';
import { SharedModule } from '../../shared.module';
import { MaterialMdcModule } from '../../material-mdc.module';

@NgModule({
  declarations: [
    ValidatePasswordComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialMdcModule
  ],
  exports: [
    ValidatePasswordComponent
  ]
})
export class ValidatePasswordModule { }
